module.exports = __webpack_public_path__ + "img/user-image.29820255.jpg";